import { render, staticRenderFns } from "./ckhcgl.vue?vue&type=template&id=1c6bd47e&scoped=true&"
import script from "./ckhcgl.vue?vue&type=script&lang=js&"
export * from "./ckhcgl.vue?vue&type=script&lang=js&"
import style0 from "./ckhcgl.vue?vue&type=style&index=0&id=1c6bd47e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6bd47e",
  null
  
)

export default component.exports